import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=d6f26f98&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=d6f26f98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f26f98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f26f98')) {
      api.createRecord('d6f26f98', component.options)
    } else {
      api.reload('d6f26f98', component.options)
    }
    module.hot.accept("./Support.vue?vue&type=template&id=d6f26f98&scoped=true", function () {
      api.rerender('d6f26f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/Support.vue"
export default component.exports